class EventLoader {
  constructor() {
    this.events = new Map();
    this.loaded = new Set();
  }

  addEventListener(eventName, callback) {
    if (typeof callback !== "function") return;

    if (this.isLoaded(eventName)) {
      callback.call(null, this);
      return;
    }

    if (!this.events.has(eventName)) {
      this.events.set(eventName, []);
    }

    this.events.get(eventName).push(callback);
  }

  fireEvent(eventName, ...args) {
    this.loaded.add(eventName);

    const callbacks = this.events.get(eventName) || [];
    this.events.set(eventName, []);
    callbacks.forEach((callback) => callback.call(null, this, ...args));
  }

  isLoaded(eventName) {
    return this.loaded.has(eventName);
  }
}

window.RailsConfig = window.RailsConfig || {};
window.eventLoader = window.eventLoader || new EventLoader();
